import * as React from 'react';
import { loggedOut } from "../../actions";
import { connect } from "react-redux";
import { Navbar, Nav, NavItem, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './header.css';
import Logo from '../../utils/images/HazenLogo.svg'
import {State} from "../../types";  
import Logout from '../Login/Logout'
interface myState {
    dashboardState: boolean
}

interface myProps {
    loginStatus: any,
    serverHost: string,
    path: string,
    dispatch: Function

}
export const Header = connect((state: State, ownProps: any) => {
    return {
        loginStatus: state.login
    }
  })

(class Header extends React.Component<myProps, myState> {
    constructor(props: myProps){
        super(props)
        this.state={
            dashboardState:true
        }
    
    this.checkthepage = this.checkthepage.bind(this)
    }
    checkthepage(){
        const pageLocation = window.location.href.split('/');
        const placeLocation = pageLocation[pageLocation.length - 1];
       console.log(placeLocation);
    }

    render() {
        const { loginStatus } = this.props;
        console.log("LoginStatus from header", loginStatus.login.isLogged);
        this.checkthepage();
        if(window.localStorage["isLogged"]=== "true")
        return ( 
        <div >
           <Navbar className="dashboard-header" >
            <Navbar.Header>
            <Navbar.Brand >
                <a href="http://hazen.ai" target="_blank" >
                    <img
                    src={Logo}
                    alt=" "
                    style={{ height: 41, padding: 0, marginTop: 5 }}
                    />
                </a>
            </Navbar.Brand>
            <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
               <Nav>
                    {/* <NavItem componentClass="span" active={this.state.dashboardState}> 
                    <Link to="/Dashboard">Dashboard</Link>
                    </NavItem> */}
                    <NavItem componentClass = 'violations-history' className='violations-history' > 
                    <Link to="/eventsHistory">Events History</Link>
                    </NavItem >
                    <NavItem componentClass="selectcamera"  className='selectcamera' > 
                    <Link to="/selectcamera">Select Camera</Link>
                    </NavItem >
                    <div className='camera-name'>
                        <text style={{color: '#FF6060', fontSize: 20}}>{window.localStorage.getItem("camLabel")}</text>
                    </div>
                    <Button className="logout" style={{width:89, height: 35}}>
                        <Logout  show={true} />
                    </Button>
                </Nav>
            </Navbar.Collapse>
          </Navbar>
      </div>)
      else return (<div></div>)
    }
    handleClick(){

     const { dispatch } = this.props;
            dispatch(loggedOut());
        }
})
export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx